import { FlyInModel } from 'models';

export const adaptFlyInModel = (response: any): FlyInModel | null => {
  if (!hasToastMessage(response)) {
    return null;
  }

  return {
    text: response.data.propertyOffers.toastMessage.value,
  } as FlyInModel;
};

export const hasToastMessage = (response: any) => Boolean(response?.data?.propertyOffers?.toastMessage);
